import { useEffect, useState } from "react";
import API from "../api";
import { useNavigate, useSearchParams } from "react-router-dom";

function NewConversation() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [groupName, setGroupName] = useState("");
  const [selectedMembers, setSelectedMembers] = useState([]);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const mode = searchParams.get("mode");
  const isGroupMode = mode === "group";
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await API.get("/members");
        setMembers(
  res.data.filter(
    (m) => Number(m.id) !== Number(user.id)
  )
);
      } catch (err) {
        console.log(err);
        alert("Erreur membres");
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, []);

  useEffect(() => {
    const userId = searchParams.get("user");

    if (userId && !isGroupMode) {
      startConversation(Number(userId));
    }
  }, [searchParams, isGroupMode]);

  const startConversation = async (userId) => {
    try {
      const res = await API.post("/conversation", {
        user2: userId,
      });

      navigate(`/chat/${res.data.conversationId}`);
    } catch (err) {
      console.log("Erreur création conversation :", err);
      alert(
        err?.response?.data?.message ||
          JSON.stringify(err?.response?.data) ||
          err?.message ||
          "Erreur création conversation"
      );
    }
  };

  const toggleMember = (id) => {
    setSelectedMembers((prev) =>
      prev.includes(id) ? prev.filter((memberId) => memberId !== id) : [...prev, id]
    );
  };

  const createGroup = async () => {
    if (!groupName.trim()) {
      alert("Nom du groupe obligatoire");
      return;
    }

    if (selectedMembers.length < 2) {
      alert("Choisis au moins 2 membres pour créer un groupe");
      return;
    }

    try {
      const res = await API.post("/conversations/group", {
        name: groupName.trim(),
        userIds: selectedMembers,
      });

      navigate(`/chat/${res.data.conversationId}`);
    } catch (err) {
      console.log("Erreur création groupe :", err);
      alert(
        err?.response?.data?.message ||
          JSON.stringify(err?.response?.data) ||
          err?.message ||
          "Erreur création groupe"
      );
    }
  };

  if (loading) {
    return <div style={styles.loading}>Chargement...</div>;
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <p style={styles.kicker}>{isGroupMode ? "Groupe" : "Message privé"}</p>
        <h1 style={styles.title}>
          {isGroupMode ? "Créer un groupe" : "Choisir un membre"}
        </h1>

        <button style={styles.backButton} onClick={() => navigate("/conversations")}>
          Retour
        </button>
      </div>

      {isGroupMode && (
        <div style={styles.groupBox}>
          <label style={styles.label}>Nom du groupe</label>
          <input
            style={styles.input}
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            placeholder="Ex : Bureau, Tenue, Commission..."
            placeholderTextColor="rgba(255,255,255,0.45)"
          />

          <p style={styles.counter}>
            {selectedMembers.length} membre
            {selectedMembers.length > 1 ? "s" : ""} sélectionné
            {selectedMembers.length > 1 ? "s" : ""}
          </p>

          <button style={styles.createButton} onClick={createGroup}>
            Créer le groupe
          </button>
        </div>
      )}

      <div style={styles.list}>
        {members.map((m) => {
          const selected = selectedMembers.includes(m.id);

          return (
            <div
              key={m.id}
              onClick={() => {
                if (isGroupMode) {
                  toggleMember(m.id);
                } else {
                  startConversation(m.id);
                }
              }}
              style={{
                ...styles.item,
                ...(selected ? styles.itemSelected : {}),
              }}
            >
              <div style={styles.avatar}>
                {(m.firstname?.charAt(0) || "").toUpperCase()}
                {(m.lastname?.charAt(0) || "").toUpperCase()}
              </div>

              <div style={styles.memberInfo}>
                <strong>
                  {m.firstname} {m.lastname}
                </strong>
                <span>{m.role}</span>
              </div>

              {isGroupMode && (
                <div style={selected ? styles.checkSelected : styles.check}>
                  {selected ? "✓" : ""}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default NewConversation;

const gold = "#8FAE5D";

const styles = {
  container: {
  minHeight: "100vh",
  background: "linear-gradient(180deg, #F4F0FA 0%, #E6DDF4 100%)",
  color: "#3B3450",
  padding: "24px 18px 120px",
  boxSizing: "border-box",
},

  header: {
    marginBottom: 20,
  },

  kicker: {
    margin: 0,
    color: "#8FAE5D",
    textTransform: "uppercase",
    letterSpacing: 2,
    fontSize: 12,
    fontWeight: 800,
  },

  title: {
    margin: "6px 0 12px",
    fontSize: 30,
    fontWeight: 900,
  },

  backButton: {
    border: "1px solid rgba(143,174,93,0.35)",
    background: "rgba(255,255,255,0.85)",
    color: "#8FAE5D",
    padding: "10px 14px",
    fontWeight: 800,
  },

    groupBox: {
  background: "rgba(255,255,255,0.90)",
  border: "1px solid rgba(143,174,93,0.20)",
  borderRadius: 22,
  padding: 16,
  marginBottom: 18,
},
  

  label: {
    display: "block",
    marginBottom: 8,
    color: "#5A556D",
    fontSize: 14,
    fontWeight: 800,
  },

  input: {
    width: "100%",
    height: 48,
    borderRadius: 16,
     border: "1px solid rgba(143,174,93,0.28)",
  background: "rgba(255,255,255,0.95)",
  color: "#3B3450",
    padding: "0 14px",
    fontSize: 16,
    outline: "none",
    boxSizing: "border-box",
  },

  counter: {
    margin: "12px 0",
    color: "#6B6780",
    fontSize: 14,
  },

  createButton: {
    width: "100%",
    border: "none",
    borderRadius: 16,
    padding: "14px 16px",
    background: "linear-gradient(135deg, #8FAE5D, #9AB86A)",
    color: "#fff",
    fontWeight: 900,
    fontSize: 15,
  },

  list: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },

  item: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: 14,
    borderRadius: 22,
    background: "rgba(255,255,255,0.90)",
    border: "1px solid rgba(143,174,93,0.16)",
    cursor: "pointer",
  },

  itemSelected: {
    border: "1px solid rgba(143,174,93,0.55)",
    background: "rgba(143,174,93,0.14)",
  },

  avatar: {
    width: 48,
    height: 48,
    borderRadius: "50%",
     background: "rgba(255,255,255,0.90)",
    border: "1px solid rgba(143,174,93,0.35)",
    color: "#8FAE5D",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 900,
    flexShrink: 0,
  },

  memberInfo: {
    color: "#3B3450",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
  },

  check: {
    width: 26,
    height: 26,
    borderRadius: "50%",
    border: "1px solid rgba(214,181,109,0.4)",
    flexShrink: 0,
  },

  checkSelected: {
    width: 26,
    height: 26,
    borderRadius: "50%",
    background: "linear-gradient(145deg, #f3d77b, #b9872f)",
    color: "#071016",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 900,
    flexShrink: 0,
  },

  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "linear-gradient(180deg, #F4F0FA 0%, #E6DDF4 100%)",
    color: "#3B3450",
  },
};